module.exports = __webpack_public_path__ + "static/portfolio-3-63e56d6266113c99ca6b323a818891f0.jpg";